import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const c = l((i, o) => /* @__PURE__ */ e.jsx(
  t,
  {
    ref: o,
    ...i,
    image: (s) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#1D1D44",
            fillRule: "evenodd",
            d: "M7.935 16c.615-.95.93-2.64 1.34-2.495s.473.153 1.268.363c1.835.486 2.807.228 2.711-.53-.13-1.022.216-1.274.216-1.274s.491-.076.491-.479-.242-.373-.242-.373.208-.135.36-.299c.151-.164-.118-.411-.118-.411s-.445-.196-.242-1.16c0 0 .196-.054.504-.184.6-.254.456-.571 0-1.008-.505-.484-.969-1.259-.969-1.704 0-.27-.008-1.22 0-1.458.03-.878-.092-2.13-.969-3.029C10.687.32 8.733-.359 6.02.184S2.481 2.455 1.895 4.27c-.587 1.815 0 3.194.729 4.59.415.797 1.382 1.822 1.116 3.204-.184.954-1.116 2.694-1.116 2.694",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
c.displayName = "RightFacingSelfieIcon";
export {
  c as RightFacingSelfieIcon,
  c as default
};
//# sourceMappingURL=index.js.map
